/**
 * バンドルミックスマッチ設定画面　入力VOクラス
 */
export class KYMW1308InputModel {
  /** 処理区分(1：バンドルミックスマッチ設定、2：バンドルミックスマッチ追加) */
  public accessDiv: string = null;
  /** 編集ロック(true：ロック取得、false：ロック解除) */
  public editLock: boolean = <boolean>false;
  /** 受注コード */
  public orderCode: string = null;
  /** 媒体区分 */
  public mediumType: string = null;
  /** プロモーションＮＯ */
  // 項番2593 START
  // public promotionNo: string = null;
  public promotionNo: string = <string>'';
  // 項番2593 END
  /** Ｐコードリスト */
  public pCodeList: Array<any> = new Array<any>();
}
